PJQ.models.directcosts.DirectCost = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        if (this.isNew()) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'directcosts'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'directcosts',
                value: this.get('id')
            }
        ]);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.attachments = new PJQ.collections.directcosts.Attachments(model.attachments);
        this.lineItems = new PJQ.collections.directcosts.LineItems(model.lineItems);

        if (model && model.vendor)
            this.vendor = new PJQ.models.contacts.Contact(model.vendor);

        if (model && model.reportedBy)
            this.reportedBy = new PJQ.models.contacts.Contact(model.reportedBy);

        return model;
    },
    beforeSave: function () {
        this.set('attachments', this.attachments.toJSON());
        this.set('lineItems', this.lineItems.toJSON());
    },
    syncERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalId', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    },
    makeERPUrl: function (integration) {
        let externalId = this.externalId();
        if (_.size(externalId) === 0) {
            return '';
        }

        switch (integration.get('name')) {
            case PJQ.constants.integrations.providers.QBO.name:
                return '';
            default:
                return '';
        }
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    }
});

PJQ.models.directcosts.LineItem = PJQ.models.budget.BaseLineItem.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    parse: function (model) {
        if (!model)
            return model;

        if (model && model.group) {
            this.group = new PJQ.models.groups.Group(model.group);
        } else
            this.group = null;

        return model;
    }
});

PJQ.models.directcosts.Attachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.directcosts.CustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'directcosts'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.directcosts.CustomFieldChoice = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'directcosts'
            },
            {
                endpoint: 'customfields',
                value: this.get('customFieldId')
            },
            {
                endpoint: 'choices',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.directcosts.DirectCostFieldSetting = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: this.id ? this.id : 'directcosts'
            }
        ]);
    }
});


PJQ.models.directcosts.Settings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'directcosts'
            },
            {
                endpoint: 'settings'
            }
        ]);
    }
});

PJQ.models.directcosts.UserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'directcosts'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.collections.directcosts.DirectCosts = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.directcosts.DirectCost,
    endpoint: function () {
        let params = [
            {
                parameter: 'search',
                value: this.options.search
            },
            {
                parameter: 'typeFilter',
                value: this.options.typeFilter
            },
            {
                parameter: 'statusFilter',
                value: this.options.statusFilter
            }
        ];
        if (this.options.costCodeId && this.options.costTypeId) {
            params.push({
                parameter: 'costCodeId',
                value: this.options.costCodeId
            }, {
                parameter: 'costTypeId',
                value: this.options.costTypeId
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'directcosts'
            }
        ], params);
    },
    getTotalAmountsByStatus: function () {
        let result = {};
        result[PJQ.constants.directcosts.directCostStatus.DRAFT] = 0;
        result[PJQ.constants.directcosts.directCostStatus.PENDING] = 0;
        result[PJQ.constants.directcosts.directCostStatus.APPROVED] = 0;
        result[PJQ.constants.directcosts.directCostStatus.REVISE] = 0;
        _.each(this.models, function (directCost) {
            result[directCost.get('statusId')] += directCost.get('amount');
        });
        return result;
    }
});

PJQ.collections.directcosts.LineItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.directcosts.LineItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'directcosts',
                value: this.options.directCostId
            },
            {
                endpoint: 'lineitems'
            }
        ]);
    }
});

PJQ.collections.directcosts.Attachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.directcosts.Attachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments',
                value: this.options.commitmentId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.directcosts.CustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.directcosts.CustomField,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'directcosts'
                },
                {
                    endpoint: 'customfields'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'directcosts'
            },
            {
                endpoint: 'customfields'
            }
        ]);
    }
});

PJQ.collections.directcosts.CustomFieldChoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.directcosts.CustomFieldChoice
});

PJQ.collections.directcosts.DirectCostFieldSettings = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.directcosts.DirectCostFieldSetting,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: 'directcosts'
            }
        ]);
    }
});